export class Ease {


    public static functions: { slug: string; }[] = [
        {
            "slug": "cubicInOut"
        },
        {
            "slug": "cubicIn"
        },
        {
            "slug": "cubicOut"
        },
        {
            "slug": "linear"
        },
        {
            "slug": "quadIn"
        },
        {
            "slug": "quadOut"
        },
        {
            "slug": "quadInOut"
        },
        {
            "slug": "quartIn"
        },
        {
            "slug": "quartOut"
        },
        {
            "slug": "quartInOut"
        },
        {
            "slug": "quintIn"
        },
        {
            "slug": "quintOut"
        },
        {
            "slug": "quintInOut"
        },
        {
            "slug": "sineIn"
        },
        {
            "slug": "sineOut"
        },
        {
            "slug": "sineInOut"
        },
        {
            "slug": "expoIn"
        },
        {
            "slug": "expoOut"
        },
        {
            "slug": "expoInOut"
        },
        {
            "slug": "circIn"
        },
        {
            "slug": "circOut"
        },
        {
            "slug": "circInOut"
        },
        {
            "slug": "backIn"
        },
        {
            "slug": "backOut"
        },
        {
            "slug": "backInOut"
        },
        {
            "slug": "elasticIn"
        },
        {
            "slug": "elasticOut"
        },
        {
            "slug": "elasticInOut"
        },
        {
            "slug": "bounceIn"
        },
        {
            "slug": "bounceOut"
        },
        {
            "slug": "bounceInOut"
        }
    ];


    public static cubicInOut(t: number): number {
        return t < 0.5 ? 4.0 * t * t * t : 0.5 * Math.pow(2.0 * t - 2.0, 3.0) + 1.0;
    }

    public static cubicIn(t: number): number {
        return t * t * t;
    }

    public static cubicOut(t: number): number {
        return --t * t * t + 1;
    }

    public static linear(t: number): number {
        return t;
    }

    public static quadIn(t: number): number {
        return t * t;
    }

    public static quadOut(t: number): number {
        return t * (2 - t);
    }

    public static quadInOut(t: number): number {
        return t < 0.5 ? 2.0 * t * t : -1.0 + (4.0 - 2.0 * t) * t;
    }

    public static quartIn(t: number): number {
        return t * t * t * t;
    }

    public static quartOut(t: number): number {
        return 1 - (--t * t * t * t);
    }

    public static quartInOut(t: number): number {
        return t < 0.5 ? 8.0 * t * t * t * t : 1.0 - 8.0 * (--t) * t * t * t;
    }

    public static quintIn(t: number): number {
        return t * t * t * t * t;
    }

    public static quintOut(t: number): number {
        return 1 + (--t) * t * t * t * t;
    }

    public static quintInOut(t: number): number {
        return t < 0.5 ? 16.0 * t * t * t * t * t : 1.0 + 16.0 * (--t) * t * t * t * t;
    }

    public static sineIn(t: number): number {
        return 1 - Math.cos(t * Math.PI / 2);
    }

    public static sineOut(t: number): number {
        return Math.sin(t * Math.PI / 2);
    }

    public static sineInOut(t: number): number {
        return 0.5 * (1 - Math.cos(Math.PI * t));
    }

    public static expoIn(t: number): number {
        return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
    }

    public static expoOut(t: number): number {
        return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
    }

    public static expoInOut(t: number): number {
        if (t === 0 || t === 1) return t;
        if ((t *= 2) < 1) return 0.5 * Math.pow(2, 10 * (t - 1));
        return 0.5 * (2 - Math.pow(2, -10 * --t));
    }

    public static circIn(t: number): number {
        return 1 - Math.sqrt(1 - t * t);
    }

    public static circOut(t: number): number {
        return Math.sqrt(1 - --t * t);
    }

    public static circInOut(t: number): number {
        return t < 0.5 ? 0.5 * (1 - Math.sqrt(1 - 4 * t * t)) : 0.5 * (Math.sqrt(1 - -4 * (--t) * t) + 1);
    }

    public static backIn(t: number): number {
        return t * t * (2.70158 * t - 1.70158);
    }

    public static backOut(t: number): number {
        return --t * t * (2.70158 * t + 1.70158) + 1;
    }

    public static backInOut(t: number): number {
        var s = 1.70158 * 1.525;
        if ((t *= 2) < 1) return 0.5 * (t * t * ((s + 1) * t - s));
        return 0.5 * ((t -= 2) * t * ((s + 1) * t + s) + 2);
    }

    public static elasticIn(t: number): number {
        if (t === 0 || t === 1) return t;
        return -Math.pow(2, 10 * (t - 1)) * Math.sin((t - 1.1) * 5 * Math.PI);
    }

    public static elasticOut(t: number): number {
        if (t === 0 || t === 1) return t;
        return Math.pow(2, -10 * t) * Math.sin((t - 0.1) * 5 * Math.PI) + 1;
    }

    public static elasticInOut(t: number): number {
        if (t === 0 || t === 1) return t;
        t *= 2;
        if (t < 1) return -0.5 * Math.pow(2, 10 * (t - 1)) * Math.sin((t - 1.1) * 5 * Math.PI);
        return 0.5 * Math.pow(2, -10 * (t - 1)) * Math.sin((t - 1.1) * 5 * Math.PI) + 1;
    }

    public static bounceIn(t: number): number {
        return 1 - Ease.bounceOut(1 - t);
    }

    public static bounceOut(t: number): number {
        if (t < 1 / 2.75) {
            return 7.5625 * t * t;
        } else if (t < 2 / 2.75) {
            return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
        } else if (t < 2.5 / 2.75) {
            return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
        } else {
            return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
        }
    }

    public static bounceInOut(t: number): number {
        return t < 0.5 ? Ease.bounceIn(t * 2) * 0.5 : Ease.bounceOut(t * 2 - 1) * 0.5 + 0.5;
    }
}